import { Component, inject } from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, take } from 'rxjs';

import { ToastComponent } from '@/app/shared/components/toast/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  template: `
    <router-outlet />
    <app-toast />
  `,
})
export class App {
  private readonly router = inject(Router);

  constructor() {
    // Hide the splash only once the first navigation has fully settled — i.e.
    // after the guards (and the async /auth/me session check) have resolved —
    // so the auth page is never flashed during the round-trip.
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd || event instanceof NavigationError
        ),
        take(1)
      )
      .subscribe(() => this.hideSplash());
  }

  private hideSplash(): void {
    const splash = document.getElementById('app-splash');
    if (!splash) {
      return;
    }

    splash.classList.add('app-splash--hidden');
    splash.addEventListener('transitionend', () => splash.remove(), {
      once: true,
    });
  }
}
